import React, { useEffect, useState } from "react";
import Footer from "../sections/common/Footer";
import Navbar from "../sections/common/Navbar";
import Pagination from "../sections/common/Pagination";
import { useNavigate } from "react-router-dom";
import { categoryListApi } from "../apis/propertylisting/propertyListApi";

const AllLocations = () => {
    const navigate = useNavigate()
    const [categoryData, setCategoryData] = useState(null)

    useEffect(() => {
        const fetchCategoryList = async () => {
            const response = await categoryListApi();
            const categoryList = response?.data?.data;
            setCategoryData(categoryList);
        };

        fetchCategoryList();
    }, []);

    return (
        <>
            <section>
                <Navbar />
                <section className="listing-banner">
                    <h1>All Properties</h1>
                </section>
                <section className="container blog-details-page-location">
                    <p>Home / Popular Places</p>
                </section>
                <div className="discover-section">
                    <div className="container">
                        <div className="row discover-detail-row py-3 gy-2">
                            <div className="col-12 property-heading-col" style={{ paddingTop: "20px", paddingBottom: "0px" }}>
                                <h3>Discover Popular Place</h3>

                            </div>


                            {
                                categoryData && categoryData?.location?.map((item, i) => {
                                    return <div key={i} className="col-md-4">
                                        <div className="discover-property-box" onClick={() => navigate(`/property-listing?location=${item.slug}-${item.id}`)} style={{ cursor: "pointer" }}>
                                            <img src={item.image || "/images/arizona.png"} alt="Arizona" />
                                            <div className="discover-property-title">
                                                <h5>{item.city}</h5>
                                                {/* <p>120 Properties</p> */}
                                            </div>
                                        </div>
                                    </div>
                                })
                            }



                        </div>
                    </div>
                </div>
                <Pagination />
                <Footer />
            </section>

        </>
    )
}

export default AllLocations
